import { addDoc, collection, doc, getDoc, getDocs, query, Timestamp, where } from 'firebase/firestore';
import React, { useContext, useEffect, useState } from 'react'
import { auth, db } from '../firebase'
import { googleAuth } from './GoogleAuthContext';

const AuthContext = React.createContext();

export function useAuth () {
    return useContext(AuthContext);
}

export function AuthProvider({ children }) {
    const [loading, setLoading] = useState(true);
    
    const [currentUser, setCurrentUser] = useState(() => {
        const user = auth.currentUser;
        return user;
      });

    function signup(email, password) {
        return auth.createUserWithEmailAndPassword(email, password);
    }

    function login(email, password, type) {
      if(type === undefined || type === "regular")
        return auth.signInWithEmailAndPassword(email, password);
      
      return googleAuth();
    }

    function logout(){
      return auth.signOut();
    }

    function resetPassword(email) {
      auth.sendPasswordResetEmail(email);
    }

    
    
    const [userRole, setUserRole] = useState(''); 
    const [userName, setUserName] = useState('');
    const [userId, setUserId] = useState('');
  
    const getUser = async () => {
      if(auth.currentUser == null) return null;

      const userQuery = query(collection(db, 'Users'), where("identity_id", "==", auth.currentUser.uid))
      const querySnapshot = await getDocs(userQuery);

      if(querySnapshot.size === 0 && currentUser){
        persistUser(auth.currentUser.displayName, auth.currentUser.uid)
        setUserId(auth.currentUser.uid);
        setUserRole("Regular");
        setUserName(auth.currentUser.displayName)
      }else{
        querySnapshot.forEach((doc) => {
          // doc.data() is never undefined for query doc snapshots
          //console.log(doc.id, " => ", doc.data());
          setUserId(doc.data().identity_id);
          setUserRole(doc.data().role_name);
          setUserName(doc.data().first_name)
        }); 
      } 
    }

    async function persistUser(name, id){
      await addDoc(collection(db, 'Users'), {
        first_name: name,
        identity_id: id,
        role_name: "Regular",
        created_at: Timestamp.fromDate(new Date())
      });
    }
   
    useEffect(() => {
        const unsubscribe = auth.onAuthStateChanged(user => {
            setCurrentUser(user);
            if(user)
              getUser();
            setLoading(false)
        })
        return unsubscribe;
    }, [])

    const value = {
        currentUser,
        userRole,
        userName,
        userId,
        login,
        logout,
        signup,
        resetPassword
    }

  return (
    <AuthContext.Provider value={value}>
      {!loading && children}
    </AuthContext.Provider>
  )
}
